import * as React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { DashboardPagingProvider } from "./contexts/DashboardPagingContext";
import { RouterProvider } from "react-router/dom";
import NotificationHost from "./components/common/Alerts/NotificationHost";
import { routes } from "./routes";
import { AppSettings } from "./helpers/AppSettings";
import { AuthenticatedUserProvider } from "./providers/AuthenticatedUserProvider";
import { AppNavigationProvider } from "./contexts/AppNavigationContext";
import { AppSWRProvider } from "./providers/AppSWRProvider";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HelpDrawerProvider } from "./contexts/HelpDrawerContext";

import "./styles/app.scss";
import { monitoring } from "./helpers/monitoring";
import { reactRootOptions } from "./helpers/reactRootOptions";

export const router = monitoring.createRouter(routes, AppSettings);

const App: React.FC = () => {
    return (
        <div>
            <RouterProvider router={router} />
            <NotificationHost />
        </div>
    );
};

const appContainer = document.getElementById("app");
if (!appContainer) throw new Error("Application container not found.");

createRoot(appContainer, reactRootOptions).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <ThemeProvider>
                <HelpDrawerProvider>
                <DashboardPagingProvider>
                    <AuthenticatedUserProvider>
                        <AppSWRProvider>
                            <AppNavigationProvider>
                                <App />
                            </AppNavigationProvider>
                        </AppSWRProvider>
                    </AuthenticatedUserProvider>
                </DashboardPagingProvider>
                </HelpDrawerProvider>
            </ThemeProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
